export default __webpack_public_path__ + "static/broth-9af59f8f8d47d76bc0c8e81534dc80a5.png";